export const BASE_URL: string = window.apiEndpoint;

export const gameRoute = (token: string) => `${BASE_URL}/participation-request/${token}`;

export const participate = (token: string) => `${BASE_URL}/participate/${token}`;
